module.exports = __webpack_public_path__ + "img/bj_05.9fd8d1d0.jpg";